export default __webpack_public_path__ + "0a79f1db45c394ab6b348d736c122e15.png";